import type { GameThemeNodeFragment } from "@workspace/casino_core/fragments/GameFragment";
import ThemeLink from "./ThemeLink";

type Props = {
  themes?: (GameThemeNodeFragment | undefined)[];
};

const ThemeLinksSection: FC<Props> = ({ themes }) => {
  if (!themes || themes.length === 0) {
    return null;
  }
  const themeLinks = getThemeLinks(themes);
  return <div className="flex max-w-xs flex-row flex-wrap">{themeLinks}</div>;
};

const getThemeLinks = (themes: (GameThemeNodeFragment | undefined)[]) =>
  themes.map((theme) => (
    <ThemeLink key={theme?.node?.id} handle={theme?.node?.handle ?? ""} />
  ));

export default ThemeLinksSection;
